import React, { useEffect, useState } from "react";
import {
  RoutePath,
  TransportCategories,
  apiPath,
} from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import { useNavigate, useParams } from "react-router-dom";
import CustomMultiInputForm from "../../components/globalForm/CustomMultiInputForm";
import { toast } from "react-toastify";

function AddIntercityTransport() {
  const { intercityApi } = apiPath;
  const [multiFormDataX, setMultiFormDataX] = useState([]);
  const { productsApi } = apiPath;
  const { productDetails } = RoutePath;
  const navigate = useNavigate();

  // Form data
  const data = [
    {
      elementType: "file",
      label: "Transport image",
      type: "Text",
      name: "image",
      required: false,
      fullCol: true,
      fullHeight: true,
    },
    {
      elementType: "file",
      label: "Price Chart image",
      type: "Text",
      name: "priceChart",
      required: false,
      fullCol: true,
      fullHeight: true,
    },
    {
      elementType: "textField",
      label: "Transport Name",
      type: "Text",
      name: "busName",
      required: true,
    },
    {
      elementType: "textField",
      label: "Transport Name - Bangla",
      type: "Text",
      name: "busNameBn",
      required: true,
    },
    {
      elementType: "select",
      label: "Transport category",
      type: "Text",
      name: "category",
      required: true,
      options: TransportCategories,
      defaultValue: "Select category",
    },
    {
      elementType: "input",
      label: "Estimated duration",
      type: "Text",
      name: "duration",
      required: false,
      fullCol: true,
    },
    {
      elementType: "input",
      label: "Estimated duration - Bangla",
      type: "Text",
      name: "durationBn",
      required: false,
      fullCol: true,
    },
    {
      elementType: "input",
      label: "transport fare",
      type: "Text",
      name: "fair",
      required: false,
      fullCol: true,
    },
    {
      elementType: "input",
      label: "transport fare - Bangla (৳)",
      type: "Text",
      name: "fairBn",
      required: false,
      fullCol: true,
    },
    {
      elementType: "textField",
      label: "Extra Information",
      type: "Text",
      name: "info",
      required: false,
      fullCol: true,
    },
    {
      elementType: "textField",
      label: "Extra Information - Bangla",
      type: "Text",
      name: "infoBn",
      required: false,
      fullCol: true,
    },
  ];

  // Toast settings
  const toastOptions = {
    autoClose: 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  };

  const update = async (data) => {
    let newData = { ...data };
    newData.image = {
      url: data.image,
      name: data.busName,
    };
    newData.priceChart = {
      url: data.priceChart,
    };

    if (data.category === "Select category") {
      toast.warn("Please choose a category", toastOptions);
    }

    if (data.category !== "Select category" && data.city !== "Select City") {
      newData.stoppage = multiFormDataX;

      // check if route exist
      if (multiFormDataX?.length > 0) {
        // API call
        const res = await updateData(intercityApi, newData, null, true);
        if (res?.length > 0) {
          setTimeout(() => {
            navigate("/" + productDetails);
          }, 1000);
        }
      } else {
        toast.warn("Please add a route", toastOptions);
      }
    }
  };

  // function updateMultiple(formFields, name) {
  //   return formFields;
  // }

  return (
    <div>
      {/* <center>Under construction...</center> */}
      {/* Routes */}
      <div className="px-4 sm:px-8">
        <CustomMultiInputForm
          pageTitle={"Routes"}
          // update={updateMultiple}
          setMultiFormDataX={setMultiFormDataX}
          disableApiSubmit={true}
        />
      </div>
      {/* form */}
      <div className="px-4">
        <GlobalForm data={data} update={update} />
      </div>
    </div>
  );
}

export default AddIntercityTransport;
